import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import { useNavigate } from "react-router-dom";
import nodeinstance from "../../../../nodeInstance";

export default function EditemployeePopUp({
  showPromptElement,
  setPrompotElement,
  amount,
  propData,
  contractId,
}) {
  console.log("contractId......", propData);
  const [loading, setLoading] = useState(false);
  const hanldeClose = () => {
    setPrompotElement(false);
  };

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const [file, setFile] = useState();
  const [InvoiceSent, setInvoiceSent] = useState();
  const [issueDate, setIssueDate] = useState();
  const [receivedDate, setReceivedDate] = useState();
  const [referenceNumber, setReferenceNumber] = useState();

  const handleReferenceNumber = (e) => {
    setReferenceNumber(e.target.value);
  };

  const submitHandler = async (e, fileData) => {
    console.log("fileData......", fileData, file);
    setLoading(true);
    e.preventDefault();
    if (amount === 0) {
      dispatch(
        setAppError({
          msg: "Credit note amount should be greater then 0",
        })
      );
      setLoading(false);
      return;
    }
    console.log("propData........... Submit,,,,,", propData);
    const employeeData = propData.map((data) => {
      return {
        employeeId: data.employee_id,
        sec_deposit_cost: data.sec_deposit_cost,
      };
    });
    try {
      const reqObject = {
        credit_note: Math.abs(amount),
        invoice_sent_date: InvoiceSent,
        reference_number: referenceNumber,
        employee: employeeData,
        invoiceNumber: propData && propData[0]?.invoice_no,
        issue_date: issueDate,
      };

      // formData.append("file", file);

      const response = await nodeinstance.put(
        `/dashboard/visaSecOnArrival/uploadReceipt`,
        reqObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setPrompotElement(false);
        dispatch(
          setAppError({
            msg: "Successfully uploaded.",
            color: "success",
          })
        );
        setLoading(false);
        navigate("/dashboard/visa-cost-&-sec-deposit/summary-OnArrival");
      }
      console.log("success to be seen here......", response);
    } catch (error) {
      console.log("Error to be displayed here.....", error);
      setPrompotElement(true);
      setLoading(false);
      dispatch(
        setAppError({
          msg: "Error while updating credit note",
        })
      );
    }
  };

  const genereateInvoice = async () => {
    setLoading(true);
    try {
      let employeeData = propData.map((data, i) => ({
        employeeId: data.employee_id,
        secDeposite: data.sec_deposit_cost,
      }));
      const totalInvoiceAmount = propData?.reduce((total, item) => {
        return total + Number(item.sec_deposit_cost || 0);
      }, 0);

      const reqObject = {
        contract_number: propData && propData[0]?.contract_number,
        invoice_no: propData && propData[0]?.invoice_no,
        data: employeeData,
        invoice_amount: totalInvoiceAmount,
      };
      const data = await nodeinstance.post(
        "/dashboard/visaSecOnArrival/generateInvoice",
        reqObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.status === 200) {
        setPrompotElement(false);
        dispatch(
          setAppError({
            msg: "Invoice generated successfully.",
            color: "success",
          })
        );
        setLoading(false);
        navigate("/dashboard/visa-cost-&-sec-deposit/summary-OnArrival");
      }
    } catch (error) {
      setLoading(false);
      dispatch(
        setAppError({
          msg: "Error while generating new invoice",
        })
      );
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          showPromptElement ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <>
            {amount > 0 ? (
              <>
                <h2 className="m-2">{`Do you want to raise the Invoice for the amount -  ${amount}`}</h2>
                <div
                  className="flex gap-3 w-full justify-center"
                  style={{ m: 2 }}
                >
                  <button
                    className="p-2 bg-blue text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                    onClick={() => {
                      hanldeClose();
                    }}
                  >
                    {" "}
                    <p>CANCEL</p>
                  </button>

                  <button
                    className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                    onClick={() => {
                      genereateInvoice();
                    }}
                  >
                    {" "}
                    <p>Submit</p>
                    {loading ? <CgSpinner className="animate-spin" /> : ""}
                  </button>
                </div>
              </>
            ) : (
              <>
                <form
                  onSubmit={(e) => submitHandler(e, file)}
                  className="w-full"
                >
                  <div className="w-full flex flex-col gap-3 my-3 p-5">
                    <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                      <label htmlFor={`addOrEdit-name`} className="text-xs ">
                        INVOICE SENT DATE
                      </label>
                      <input
                        type="Date"
                        value={InvoiceSent}
                        className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                        onChange={(e) => {
                          setInvoiceSent(e.target.value);
                        }}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                      <label htmlFor={`addOrEdit-name`} className="text-xs ">
                        INVOICE NUMBER
                      </label>
                      <input
                        className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                        // onChange={handleAmountChange}
                        value={propData && propData[0]?.invoice_no}
                        disabled
                      />
                    </div>
                    <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                      <label htmlFor={`addOrEdit-name`} className="text-xs ">
                        CREDIT NOTE AMOUNT
                      </label>
                      <input
                        className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                        // onChange={handleAmountChange}
                        value={Math.abs(amount)}
                        disabled
                      />
                    </div>
                    <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                      <label htmlFor={`addOrEdit-name`} className="text-xs ">
                        CREDIT NOTE REFERENCE NUMBER
                      </label>
                      <input
                        className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                        onChange={handleReferenceNumber}
                      />
                    </div>
                    {/* <div className="form-control w-full ">
                      <label className="label">
                        <span className="label-text">Upload File</span>
                      </label>
                      <input
                        type="file"
                        className="file-input file-input-bordered w-full "
                        onChange={(e) => setFile(e.target.files[0])}
                        required
                        accept="image/*, application/doc, application/docx, application/pdf, application/xls, application/xlsx"
                      />
                    </div> */}
                    <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                      <label htmlFor={`addOrEdit-name`} className="text-xs ">
                        INVOICE ISSUE DATE
                      </label>
                      <input
                        type="Date"
                        value={issueDate}
                        className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                        onChange={(e) => {
                          setIssueDate(e.target.value);
                        }}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>
                    <div
                      className="flex gap-3 w-full justify-center"
                      style={{ m: 2 }}
                    >
                      <button
                        className="p-2 bg-blue text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                        onClick={() => {
                          hanldeClose();
                        }}
                      >
                        {" "}
                        <p>CANCEL</p>
                      </button>
                      <button
                        type="submit"
                        className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                      >
                        {" "}
                        <p>Submit</p>
                        {loading ? <CgSpinner className="animate-spin" /> : ""}
                      </button>
                    </div>
                  </div>
                </form>
              </>
            )}
          </>
        </div>
      </div>
    </>
  );
}
